import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Data, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeatureFlagService } from '../feature-flag.service';
import { PanAppState } from '@panamax/app-state';

const REDIRECT_URL = '/login';

/**
 * @deprecated
 * * This service is show no longer be used and removed in upcoming sprints.
 * Use the SplitGuardService instead
 */
@Injectable({
  providedIn: 'root',
})
export class FeatureFlagGuardService {
  constructor(
    private featureFlag: FeatureFlagService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    if (!route.data.featureFlags || route.data.featureFlags.length === 0) {
      return this.router.parseUrl[REDIRECT_URL];
    }
    if (!this.featureFlag.show(route.data.featureFlags)) {
      this.router.navigateByUrl(REDIRECT_URL);
      return this.router.parseUrl[REDIRECT_URL];
    } else {
      return of(true);
    }
  }
}

export interface SplitGuardRouteData extends Data {
  features: string[];
  redirectFailuresTo?: string;
}

@Injectable({
  providedIn: 'root',
})
/**
 * SplitGuardService
 *
 * @remarks
 * This guard will use split.io to verifiy whether a feature is
 * turned on or off.  If the feature is off, it will route to
 * either the /login path or the path specified in the snapshot
 * data.redirectTo variable passed into the canActivate function.
 */
export class SplitGuardService {
  redirectUrl: string;
  /**
   *
   * @param features string array of split.io features
   * @param redirectFailuresTo path to route to if feature is toggled off
   * @returns route snapshot data in proper format for the guard
   */
  static routeData(
    features: string[],
    redirectFailuresTo: string,
    allEnabled?: boolean,
  ): SplitGuardRouteData {
    return {
      features,
      redirectFailuresTo,
      allEnabled: allEnabled ?? true,
    };
  }

  constructor(
    private panAppState: PanAppState,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    this.redirectUrl = route.data?.redirectFailuresTo ?? '/login';
    const allEnabled = route.data?.allEnabled ?? true;
    const features = route.data?.features || [];
    if (!features || features.length === 0) {
      return of(this.router.parseUrl(this.redirectUrl));
    } else {
      return this.panAppState.feature$(route.data.features, allEnabled).pipe(
        map(enabled => {
          if (!enabled) {
            return this.router.parseUrl(this.redirectUrl);
          } else {
            return true;
          }
        }),
      );
    }
  }
}
